import { CalcsGridProperties } from './calcs-grid-properties'

export class CalcsResultsTypes {
    errors: any[]
    successes: any[]

    constructor(){
        this.errors = []
        this.successes = []
    }
    
}